import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class InvestmentCost extends AppRecord {
  get investment(){
    return this.constructor.employeeStore.investments.find(inv => inv.id === this.investment_id)
  }
  get issue(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.issue_id)
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get deposit(){
    return this.constructor.employeeStore.deposits.find(dep => dep.id === this.deposit_id)
  }
  get issue_name(){
    if(this.issue){
      return this.issue.name
    } else {
      return undefined
    }
  }
  get deposit_name(){
    if(this.deposit){
      return this.deposit.name
    } else {
      return undefined
    }
  }
  get entity_long_name(){
    if(this.entity){
      return this.entity.long_name
    } else {
      return undefined
    }
  }
}

export default InvestmentCost
